module.exports = __webpack_public_path__ + "fonts/baronsans-hairlineitalic-webfont.1e987daa.woff";